<script setup lang="ts">
interface WeOfferInfo {
  title: string
  description: string
  imagePath: string
}

defineProps<{
  data?: WeOfferInfo
}>()
</script>

<template>
  <div class="z-20 xs:mt-6">
    <img :src="`/services/${data?.imagePath}`" class="mx-auto mb-16 h-[355px] w-[355px] lg:hidden" alt="" />
    <div class="xs:text-justify lg:text-left">
      <WComponentTitle class="mb-4">{{ data?.title }} <br /></WComponentTitle>
      <WParagraph>{{ data?.description }} </WParagraph>
    </div>
  </div>
</template>
